var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWastage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_2265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 19.125L13.4583 14.875",
    stroke: "#3C4469",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5417 19.125L20.5417 14.875",
    stroke: "#3C4469",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.7915H29.75H28.7917C26.906 7.7915 25.9632 7.7915 25.3775 8.37729C24.7917 8.96308 24.7917 9.90589 24.7917 11.7915V22.2082C24.7917 24.0938 24.7917 25.0366 24.2059 25.6224C23.6201 26.2082 22.6773 26.2082 20.7917 26.2082H13.2083C11.3227 26.2082 10.3799 26.2082 9.79412 25.6224C9.20833 25.0366 9.20833 24.0938 9.20833 22.2082V11.7915C9.20833 9.90588 9.20833 8.96308 8.62255 8.37729C8.03676 7.7915 7.09395 7.7915 5.20833 7.7915H4.25Z",
    stroke: "#3C4469",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4584 3.54201C13.4584 3.54201 14.1667 2.125 17 2.125C19.8334 2.125 20.5417 3.54167 20.5417 3.54167",
    stroke: "#3C4469",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_2265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastage);
export default __webpack_public_path__ + "static/media/wastage.83054efd75f05c5091f10f79006478cd.svg";
export { ForwardRef as ReactComponent };